import { lazy } from "react";
// Module A — Post-Discharge Care Coordination Engine (Transition Board)
// Cola de altas recientes con LACE+, ventana TCM y closed-loop de follow-up.

const PostDischargePage = lazy(() => import("./pages/PostDischargePage"));
// Export routes for AppRouter
export const postDischargeRoutes = [
  {
    path: "/post-discharge",
    element: <PostDischargePage />,
  },
];

// Export components for external use
